import { palette } from '../utils';
const padding = '12px 40px';
const smallPadding = '12px 24px';
const paddingMBorder = '11px 39px';
const smallPaddingMBorder = '11px 23px';
const borderRadius = '8px';
export const button = {
  root: {
    borderRadius,
    padding,
    textTransform: 'none',
    fontSize: '18px',
    '&::placeholder': {
      color: 'gray'
    },
    '&.add_project_btn': {
      width: '100%',
      minHeight: '230px',
      backgroundColor: '#fff',
      borderRadius: '8px',
      '&:hover': {
        backgroundColor: '#fff'
      },
      '& .MuiButton-label': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      },
      '& .MuiButton-startIcon': {
        margin: '0 0 15px 0'
      }
    }
  },
  label: {
    lineHeight: '24px'
  },
  sizeSmall: {
    padding: smallPadding,
    fontSize: '18px'
  },
  contained: {
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none'
    }
  },
  containedPrimary: {
    '&:hover': {
      backgroundColor: palette.primary.light
    },
    '&$disabled': {
      background: palette.primary.lighter,
      color: palette.white.main
    }
  },
  containedSecondary: {
    '&$disabled': {
      background: palette.secondary.lighter,
      color: palette.white.main
    }
  },
  outlined: {
    borderRadius,
    padding: paddingMBorder
  },
  outlinedPrimary: {
    borderColor: palette.primary.main,
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#fff',
      borderColor: palette.primary.light,
      color: palette.primary.light
    },
    '&$disabled': {
      borderColor: palette.primary.lighter,
      color: palette.primary.lighter
    }
  },
  outlinedSecondary: {
    borderColor: palette.secondary.main,
    '&$disabled': {
      borderColor: palette.secondary.lighter,
      color: palette.secondary.lighter
    }
  },
  outlinedSizeSmall: {
    padding: smallPaddingMBorder
  },
  text: {
    borderRadius,
    padding
  },
  iconSizeSmall: {
    '& > *:first-child': {
      fontSize: 20
    }
  }
};